import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export type NotificationScope = 'own' | 'all';

const STORAGE_KEY = 'notification-scope';

export const useNotificationSettingsStore = defineStore('notificationSettings', () => {
  // Load initial value from localStorage, default to 'own'
  const savedScope = localStorage.getItem(STORAGE_KEY) as NotificationScope | null;
  const scope = ref<NotificationScope>(savedScope || 'own');

  // Persist to localStorage when changed
  watch(scope, (newValue) => {
    localStorage.setItem(STORAGE_KEY, newValue);
  });

  function setScope(newScope: NotificationScope) {
    scope.value = newScope;
  }

  function toggleScope() {
    scope.value = scope.value === 'own' ? 'all' : 'own';
  }

  return {
    scope,
    setScope,
    toggleScope
  };
});
